const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-50 50 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#cd9834"
    },
    points: "1.4 116.5 -1.4 113.7 12.3 100 -1.4 86.3 1.4 83.5 17.9 100 "
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#cd9834"
    },
    x: -15.1,
    y: 98,
    width: 30.2,
    height: 4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cd9834"
    },
    d: "M0 147c-25.9 0-47-21.1-47-47s21.1-47 47-47 47 21.1 47 47S25.9 147 0 147zM0 57c-23.7 0-43 19.3-43 43s19.3 43 43 43 43-19.3 43-43S23.7 57 0 57z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleArrow);
export default __webpack_public_path__ + "static/media/circleArrow.1b5f21d33354565d1f1ff7a3c0c0417f.svg";
export { ForwardRef as ReactComponent };